import Button from "lib/components/atomic/Button";
import TextField from "lib/components/atomic/TextField";
import { Form } from "lib/components/Form";
import FormControl from "lib/components/Form/FormControl";
import Image from "next/image";
import { NepalFlagIcon } from "lib/components/Icon";
import { Intent } from "lib/common/enums";
import { useRouter } from "next/dist/client/router";
import useRegister from "lib/hooks/register/useRegister";
import { useEffect } from "react";
import useGetMe from "lib/hooks/useGetMe";
import { isLoggedIn } from "redux/reducers/userSlice";
import { useSelector } from "react-redux";
import { ButtonSpinner } from "lib/components/atomic/Spinner/Spinner";
import { useAppDispatch } from "redux/hooks";
import { hideAuthDrawer, showSignInDrawer } from "redux/reducers/drawerSlice";
import next from "next";

interface RegisterProps {
  nextTab?: () => void;
}

function Register({ nextTab }: RegisterProps) {
  const { loading: userGetLoading } = useGetMe();
  const _isLoggedIn = useSelector(isLoggedIn);
  const dispatch = useAppDispatch();
  const { register, success, loading, message, error } = useRegister();

  // useEffect(() => {
  //   _isLoggedIn && dispatch(hideAuthDrawer());
  // }, [_isLoggedIn]);

  useEffect(() => {
    if (!error?.hasOccurred && nextTab && success) {
      nextTab();
    }
  }, [nextTab, success, error]);

  return userGetLoading ? (
    <p></p>
  ) : (
    <>
      <div className="flex flex-col justify-evenly px-5  my-16 items-start w-full max-w-screen-sm">
        <h4 className="text-3xl mb-3 text-gray-800 font-bold">Sign up</h4>
        <p className=" text-gray mb-8">
          Get started with Clamphook. Enter you phone number to get verified.
        </p>
        <Form
          onSubmit={(value) => {
            register(
              {
                mobile: `+977-${value.mobile}`,
              },
              "register",
            );
          }}
          className="w-full"
        >
          <FormControl
            label="Phone Number"
            name="mobile"
            required
            validationRules={[
              {
                rule: /^[9][6-8][0-9]{8}$/,
                message: "Enter a Valid Phone Number",
                intent: Intent.ERROR,
              },
            ]}
            className="my-4"
          >
            <TextField
              icon={<NepalFlagIcon size={8} className="pl-1 mr-0" />}
              type="tel"
              className="rounded-5 px-2 "
              placeholder="eg. 9841414147"
              inputStyle="pl-0"
            />
          </FormControl>
          <Button
            className="mt-5 bg-primary hover:bg-primary-600 transition-all w-full"
            type="submit"
            variant="PRIMARY"
            block
            disabled={loading}
          >
            {loading ? (
              <div>
                <span className="mr-3">Sending...</span>
                <ButtonSpinner />
              </div>
            ) : (
              <span className="text-medium font-heebo">Sign up</span>
            )}
          </Button>
        </Form>
      </div>
    </>
  );
}

export default Register;
